import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CustomModal = ({
  type,
  isTimer = false,
  show,
  onShow,
  message,
  showBtn,
  btnFn,
  btnTxt,
}) => {
  const { t } = useTranslation();
  const types = [
    { color: "text-success", icon: "fa-circle-check" },
    { color: "text-warning", icon: "fa-circle-exclamation" },
    { color: "text-danger", icon: "fa-circle-xmark" },
  ];
  const handleClose = () => onShow(false);

  useEffect(() => {
    if (show) {
      onShow(true);
      if (isTimer) {
        setTimeout(() => {
          onShow(false);
        }, 1500);
      }
    }

    if (onShow) {
      return () => {
        onShow(false);
      };
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      {/* 'show' prop is crucial */}
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i
          className={`fa-solid ${types[type].icon} ${types[type].color} fs-1 mb-3`}
        ></i>
        <p
          className="fw-bold"
          dangerouslySetInnerHTML={{ __html: t(message) }}
        />
      </Modal.Body>
      {showBtn && (
        <Modal.Footer className="m-auto">
          <Button className="btn default-btn d-block" onClick={btnFn}>
            {t(btnTxt)}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
